"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlugin = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const const_1 = require("@app/const");
const store_1 = require("@app/store");
const load_workspace_detail_1 = __importDefault(require("@app/ac/load-workspace-detail"));
const load_shifts_1 = __importDefault(require("@app/ac/load-shifts"));
const i18n_1 = require("@app/util/i18n");
const util_1 = require("@app/util");
const plugin_update_1 = __importDefault(require("@app/request/plugin-update"));
const maybe_unwrap_1 = require("../apollo/maybe-unwrap");
const is_defined_1 = require("../is-defined");
const useWorkspace_1 = require("./useWorkspace");
const usePlugin = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const auth = (0, store_1.useRootSelector)((state) => state.auth);
    const plugins = workspace?.plugins
        ?.map(maybe_unwrap_1.unwrapMaybe)
        .filter(is_defined_1.isDefined);
    const isPluginEnabled = react_1.default.useCallback((pluginName, defaultValue = false) => {
        const enabled = plugins?.find((plugin) => plugin.plugin === pluginName)?.enabled ??
            defaultValue;
        return enabled;
    }, [plugins]);
    const isPreventedByPlugin = react_1.default.useCallback((functionName) => {
        const pluginsThatPreventFn = const_1.pluginsConfig.SUPPORTED_PLUGINS.filter((p) => p?.preventsFunctions?.includes(functionName));
        if (pluginsThatPreventFn.length &&
            pluginsThatPreventFn.some((p) => isPluginEnabled(p?.id ?? ''))) {
            return true;
        }
        return false;
    }, [isPluginEnabled]);
    const togglePlugin = react_1.default.useCallback(async (pluginName, calendar) => {
        // 'dayswapspro' is an exception - it can only be enabled/disabled in admin for the whole organization
        if (pluginName === 'dayswapspro')
            return false;
        if (!workspace)
            return false;
        const isAdmin = document.querySelector('.ds-adminpanel') ||
            window.location.hostname === 'localhost' ||
            window.location.hostname === 'app.local.dayswaps.top';
        if (!isAdmin && isPreventedByPlugin('pluginActivateDeactivate')) {
            // @ts-expect-error
            util_1.notification.warn({ code: (0, i18n_1.t)('functionBlockedByPlugin') });
            return false;
        }
        const plugin = workspace.plugins?.find((p) => p?.plugin === pluginName);
        const config = const_1.pluginsConfig.SUPPORTED_PLUGINS.find((p) => p.id === pluginName);
        const newValue = !plugin?.enabled;
        const body = {
            target: {
                model: 'workspace',
                id: workspace.id,
            },
            plugin: pluginName,
            data: {
                enabled: newValue,
                options: plugin?.options || config?.options || undefined,
            },
        };
        await (0, plugin_update_1.default)(body, auth);
        if (pluginName === 'laborlaw' && calendar?.loadedPeriods?.length) {
            const period = util_1.calendarUtil.getReloadPeriod(calendar);
            if (period) {
                // @ts-expect-error
                dispatch((0, load_shifts_1.default)({ period }));
            }
        }
        await dispatch((0, load_workspace_detail_1.default)(workspace.id));
        return true;
    }, [workspace, auth, isPreventedByPlugin, dispatch]);
    return { isPluginEnabled, isPreventedByPlugin, togglePlugin };
};
exports.usePlugin = usePlugin;
